import React from "react";
import Container from "../Container";
import BGImageDisplay from "../BGImageDisplay/BGImageDisplay";
import styled from "styled-components";

const OurWorkStyles = styled.div`
  z-index: 3;
  display: grid;
  align-items: ${(props) =>
    console.log(props) || (props.bottom === "yes" && "end")};
  justify-items: ${(props) => props.bottom === "yes" && "end"};

  width: 100%;
  margin: 20px;
  .copy-with-image {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 16px;
    grid-auto-flow: column;
    margin-bottom: 14px;
    align-items: center;
    height: fit-content;
    justify-self: ${(props) => props.justifyself};
  }

  .copy {
    filter: brightness(2);
    margin-top: 14px;
    font-size: 20px;

    color: white;
    z-index: 2;
    /* font-weight: bold; */
    display: grid;
    position: relative;

    grid-gap: 1px;

    .start {
      ::before {
        position: absolute;
        left: -10px;
        content: open-quote;
        font-size: 28px;
      }
    }
    .end {
      display: flex;
      ::after {
        position: relative;
        margin-left: 6px;

        content: close-quote;
        font-size: 28px;
      }
    }
  }
`;

const OurWorkTemplate = ({
  img,
  copy,
  customerName,
  bottom,
  objectfit,
  person,
  justifyself,
}) => {
  console.log(img, copy, customerName, bottom, objectfit);
  return (
    <Container>
      <BGImageDisplay objectfit={objectfit} bgimage={img} />
      <OurWorkStyles
        bottomquote={`${16 * copy.length + 1}px`}
        bottom={bottom ? "yes" : "no"}
        justifyself={justifyself}
      >
        <div className="copy-with-image">
          <img alt="customer" src={person} />
          <div className="copy">
            {copy.map((lineitem, index) => (
              <span
                className={
                  index === 0 ? "start" : copy.length - 1 === index ? "end" : ""
                }
                key={lineitem}
              >
                {lineitem}
                {/* {copy.length - 1 === index && `  - ${customerName}`} */}
              </span>
            ))}
            <span style={{ marginTop: "3px" }}> - {customerName} </span>
          </div>
        </div>
      </OurWorkStyles>
    </Container>
  );
};

export default OurWorkTemplate;
